import React from 'react'
import Navbar from './Navbar'

const Nav = props => {
    const {
        isSideFolded,
        isMobileNavFolded,
        onSideToggle,
        onMobileNavToggle,
        onRouteChange,
        showSideNav,
        useDocsSidebarMenu,
        transparent,
        pages,
    } = props

    return (
        <div>
            <Navbar
                showSideNav={showSideNav}
                transparent={transparent}
                isSideFolded={isSideFolded}
                isMobileNavFolded={isMobileNavFolded}
                onSideToggle={onSideToggle}
                onMobileNavToggle={onMobileNavToggle}
            />
        </div>
    )
};

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/index.js